import(/* webpackMode: "eager" */ "/app/src/app/FAQs/page.tsx");
